import AOCarouselLinks from '@atomic/organisms/_common/carousel-links/carousel-links';

export default function AOClpKeyPageLinks() {
  const initiate = () => {
    const keyPageLinksClass = '.js-ao-key-page-links';
    const $keyPageLinks = $(keyPageLinksClass);

    if (!$keyPageLinks.length) return;

    $keyPageLinks.each((_, el) => {
      const clpBlockId = $(el).data('block-id');
      const placesCarousel = new AOCarouselLinks(`.js-ao-key-page-links__carousel__${clpBlockId}`);
      placesCarousel.initiate();
    });
  };

  return { initiate };
}
